import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { UserOutput } from "~@/graphql/codegen/generated";

interface CurrentClientState {
  currentClient?: UserOutput;
}

const initialState: CurrentClientState = {
  currentClient: undefined,
};

const currentClientSlice = createSlice({
  name: "currentClient",
  initialState,
  reducers: {
    setCurrentClient(state, action: PayloadAction<UserOutput | undefined>) {
      state.currentClient = action.payload;
    },
    clearCurrentClient(state) {
      state.currentClient = undefined;
    },
  },
});

export const { setCurrentClient, clearCurrentClient } =
  currentClientSlice.actions;
export default currentClientSlice.reducer;
